import {
  aThreatIntelItemPage,
  mockThreatIntelItemsSearchOperationQuery,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

export const handlers = [
  mockThreatIntelItemsSearchOperationQuery(
    async ({ query: _query, variables: _variables }) => {
      await delay(1500);
      return HttpResponse.json({
        data: {
          __typename: 'Query',
          threatIntelItems: aThreatIntelItemPage(),
        },
      });
    }
  ),
];
